import React from 'react';

import styles from './styles/styles.module.scss';

class SectionDivider extends React.Component {
  render() {
    return (
      <div className={styles.wrapper}>
        <span className={styles.line} />
        <span className={styles.text}>{this.props.children}</span>
        <span className={styles.line} />
      </div>
    );
  }
}

export default SectionDivider;
